export default "https://cdn-static.gokick.com/assets/5a032fdfc840f3d1fce44ec205c52ed2ca8e0677/images/two-pack.1e6632cffb735562eaf44e7ebc36435e.png";